<template>
  <subscription-type-button
    @subscription-type-selected="(...args) => this.$emit('subscription-type-selected', ...args)"
    :selected="selected"
    :subscription-type="SUBSCRIPTION_TYPES.YEARLY"
    :main-text="'מינוי שנתי'"
    :sub-text="'חיוב חד פעמי'"
    :price="pricing.annual"
    :sub-price="yearlyPricingPerMonth"
    :extra-text="yearlyDiscountText" />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { SUBSCRIPTION_TYPES } from '@/constants/subscription-state';
import SubscriptionTypeButton from './SubscriptionTypeButton.vue';

export default {
  name: 'SubscriptionTypeButtonAnnual',
  components: {
    SubscriptionTypeButton,
  },
  props: {
    selected: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState('subscription', ['pricing']),
    ...mapGetters('subscription', ['yearlyPricingPerMonth']),
    yearlyPercentageDiscount() {
      return Number(((this.pricing.monthly - this.yearlyPricingPerMonth) / this.pricing.monthly) * 100).toFixed(0);
    },
    yearlyDiscountText() {
      return `${this.yearlyPercentageDiscount}% הנחה`;
    },
  },
  data() {
    return {
      SUBSCRIPTION_TYPES,
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
